module.exports = __webpack_public_path__ + "img/Icon open-account-logout.c8cfb329.svg";